import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Slider,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../../utils/cropImage";

export const CropDialog = ({ open, imageSrc, onClose, onCropDone }) => {
	const [crop, setCrop] = useState({ x: 0, y: 0 });
	const [zoom, setZoom] = useState(1);
	const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
	const [filename, setFilename] = useState("");

	const handleCropComplete = useCallback((_, areaPixels) => {
		setCroppedAreaPixels(areaPixels);
	}, []);

	useEffect(() => {
		if (imageSrc) {
			const filename = imageSrc.split("/").pop(); // e.g. ACbUJVPD_b89...e9.jpg
			const nameWithoutExt = filename.split(".")[0];
			setFilename(`main-image-${nameWithoutExt}`);
		}
	}, [imageSrc]);

	const handleCropSave = async () => {
		try {
			const croppedFile = await getCroppedImg(
				imageSrc,
				croppedAreaPixels,
				filename
			);
			onCropDone(croppedFile);
			setCrop({ x: 0, y: 0 });
			setZoom(1);
			setCroppedAreaPixels(null);
			setFilename("");
			onClose();
		} catch (e) {
			console.error(e);
		}
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>Crop Image</DialogTitle>
			<DialogContent
				sx={{
					// my: 2,
					position: "relative",
					height: 700,
					// background: "red",
				}}
			>
				<Box className="crop-container">
					<Cropper
						image={imageSrc}
						crop={crop}
						zoom={zoom}
						onCropChange={setCrop}
						onZoomChange={setZoom}
						onCropComplete={handleCropComplete}
						aspect={3 / 4}
						objectFit="contain"
					/>
				</Box>
				<Box className="controls">
					<Slider
						value={zoom}
						min={1}
						max={3}
						step={0.1}
						onChange={(e, zoom) => setZoom(zoom)}
						classes={{ container: "slider" }}
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button variant="contained" onClick={handleCropSave}>
					Crop & Save
				</Button>
			</DialogActions>
		</Dialog>
	);
};
